import _ from 'lodash';
import { fromEvent, Subscription } from 'rxjs';
import Component from '../classes/component';

const SELECTORS = {
  prevButton: '.nav-btn.prev',
  nextButton: '.nav-btn.next',
  timeline: '.events-container',
  track: '.slick-track',
  description: '.description-wrapper > .description',
};

class Timeline extends Component<typeof SELECTORS> {
  protected _selectors = SELECTORS;

  private _eventClickSub?: Subscription;

  private get timeline() {
    return this._getChild('timeline');
  }

  private _prev() {
    if (this._isSlick) {
      jQuery(this.timeline).slick('slickPrev');
    } else {
      const { currentIndex } = this._getCurrentState();
      const nextIndex = currentIndex - 1;
      if (nextIndex >= 0) {
        this._goTo(nextIndex);
      }
    }
  }

  private _next() {
    if (this._isSlick) {
      jQuery(this.timeline).slick('slickNext');
    } else {
      const { items, currentIndex } = this._getCurrentState();
      const nextIndex = currentIndex + 1;
      if (nextIndex < items.length) {
        this._goTo(nextIndex);
      }
    }
  }

  private get _isSlick() {
    return this.timeline.classList.contains('slick-initialized');
  }

  private _updateDescriptions(nextIndex: number, currentIndex?: number) {
    const descriptions = jQuery(this.container).find('.descriptions-wrapper').children();

    if (_.isNumber(currentIndex)) {
      descriptions.eq(currentIndex).animate({ opacity: 0 }, 150, () => {
        descriptions.eq(nextIndex).animate({ opacity: 1 }, 150);
      });
    } else {
      descriptions.css({ opacity: 0 });
      descriptions.eq(nextIndex).css({ opacity: 1 });
    }
  }

  private _handleSlickChange(...params: any) {
    const currentIndex = params[2];
    const nextIndex = params[3];
    this._updateDescriptions(nextIndex, currentIndex);
  }

  private _getCurrentState() {
    const items = Array.from(this.timeline.children);
    const current = this.timeline.querySelector('.current');
    const currentIndex = items.indexOf(current);

    return { items, currentIndex };
  }

  private resetItemListeners() {
    const items = jQuery(this.timeline).find('.event');
    const event = fromEvent(items, 'click');
    this._eventClickSub?.unsubscribe();
    this._eventClickSub = event.subscribe(this._selectItem.bind(this));
  }

  private _goTo(index: number) {
    if (this._isSlick) {
      jQuery(this.timeline).slick('slickGoTo', index);
    } else {
      const { items, currentIndex } = this._getCurrentState();
      items.forEach(item => item.classList.remove('current'));
      items[index].classList.add('current');
      this._updateDescriptions(index, currentIndex);
    }
  }

  private _selectItem(event: globalThis.JQuery.ClickEvent) {
    event.stopPropagation();
    const item = jQuery(event.currentTarget);

    let index: number;
    if (this._isSlick) {
      const slide = item.parents('.slick-slide').get(0);
      index = parseInt(jQuery(slide).attr('data-slick-index'));
    } else {
      index = jQuery(this.timeline)
        .children()
        .index(item.parent() as any);
    }

    this._goTo(index);
  }

  private _handleResize() {
    const width = jQuery(this.timeline).width();
    const parentWidth = jQuery(this.timeline).parent().width();

    if (this._isSlick) {
      const items = jQuery(this.timeline).find('.slick-track').children();

      if (items.length * items.width() < parentWidth) {
        jQuery(this.timeline).off('beforeChange', this._handleSlickChange.bind(this));
        jQuery(this.timeline).slick('unslick');
        const { currentIndex } = this._getCurrentState();
        this._updateDescriptions(currentIndex);
      }
    } else if (!this._isSlick && width > parentWidth) {
      jQuery(this.timeline).slick({
        arrows: false,
        infinite: false,
        draggable: false,
        variableWidth: true,
      });
      this._updateDescriptions(0);
      jQuery(this.timeline).on('beforeChange', this._handleSlickChange.bind(this));
    }

    this.resetItemListeners();
  }

  protected _onEnter() {
    this._addListener('prevButton', 'click', this._prev);
    this._addListener('nextButton', 'click', this._next);
    this._addListener(window, 'resize', this._handleResize, 500);

    this._handleResize();
  }
}

export default Timeline;
